export const get_lang = (value, langValue) => {
    if (value == null) return undefined;
    if (typeof value === "string") return value;
    if (typeof value !== "object") return undefined;

    const lang = langValue;
    let result = value.en;
    switch (lang) {
        case "en":
            result = value.en;
            break;
        case "ar":
            result = value.ar ? value.ar : value.en;
            break;
        default:
            result = value.en;
            break;
    }
    return result;
};